import { render, staticRenderFns } from "./lkuSupplier.vue?vue&type=template&id=20748424"
import script from "./lkuSupplier.vue?vue&type=script&lang=js"
export * from "./lkuSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports